<template>
  <div>
    <notifications/>

    <div v-if="!auth">
      <Auth/>
    </div>

    <div v-else>
      <div v-if="!loading" :class="{'nav-open': $sidebar.showSidebar}">
        <modals-container/>
        <router-view/>
        <!--This sidebar appears only for screens smaller than 992px-->
        <SideBar type="navbar" />
      </div>

      <div class="loading" v-else>
        <div class="spinner">
          <scale-loader  :loading="loading" />
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import Auth from './views/GeneralViews/Auth'

export default {
  components: {
    Auth
  },
  computed: {
    auth () {
      return this.$store.getters.getAuth || this.localStorage.getItem('auth') != null
    },
    loading () {
      return this.$store.getters.getLoadPage
    }
  }
}
</script>
<style lang="scss">

  .loading {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: #f4f3ef;

    .spinner {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 45%;
      &_wrap{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

</style>
